import Detail from '@vue/app/common/Detail.Row'
import { i18n } from '@js/i18n'
import { formatTokenDisplay } from '@utils/consts'

export default {
  components: { Detail },
  props: {
    tx: { type: Object, required: true }
  },
  data: _ => ({
    i18n
  }),
  methods: {
    formatTokenDisplay
  }
}



// WEBPACK FOOTER //
// ./src/vue/app/history/index/components/details.mixin.js